// frontend/src/api.js
import axios from 'axios';

// Base URL for API requests. In Docker builds, this is set via VUE_APP_API_URL
// build arg. Defaults to /api for relative paths proxied by Nginx.
const API_URL = process.env.VUE_APP_API_URL || '/api';

const apiClient = axios.create({
  baseURL: API_URL.endsWith('/') ? API_URL.slice(0, -1) : API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests if available
apiClient.interceptors.request.use((config) => {
    const token = localStorage.getItem('nitwit_auth_token')
    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }
    return config
})

// Handle 401 responses
apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            // Token expired or invalid - clear auth
            localStorage.removeItem('nitwit_auth_token')
            localStorage.removeItem('nitwit_player')
        }
        return Promise.reject(error)
    }
)

export default apiClient;
